<template>
    <v-container>
        <v-row justify="center">
            <v-col cols="12" md="10" v-if="user.status !== 103">
                <v-card flat class="px-sm-6 py-sm-4">
                    <v-row justify="center">
                        <v-col md="10" class="text-center">
                            <h2 class="mt-8">No puedes crear pagos en este momento.</h2>
                            <h3 class="mt-4">Debes completar el formulario de verificación para poder realizar pagos.</h3>
                            <v-btn class="my-12" color="primary" to="/profile/edit">Completar Perfil</v-btn>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="12" md="10" class="px-0" v-else>
                <v-card color="transparent" flat width="100%">
                    <v-card-text class="text-center px-0">
                        <v-row justify="center">
                            <v-col cols="12" sm="10" md="8" class="py-0">
                                <h3 class="text-center">Seleccione el tipo de envío</h3>
                            </v-col>
                            <v-col cols="12" sm="10" md="8" class="pb-0">
                                <v-skeleton-loader class="my-2 mx-auto" width="100%" type="list-item-avatar" v-if="loading === true"/>
                                <v-row justify="center" v-else>
                                    <v-col cols="12" class="pt-0">
                                        <div class="v-label d-inline-block mr-3" style="vertical-align: middle">Unico</div>
                                        <v-switch v-model="type" inset label="Multiple" class="mt-0 d-inline-block" style="vertical-align: middle" hide-details></v-switch>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row justify="center">
                            <v-col md="10" class="pa-0">
                                <Single :user="user" :type="type" @confirm="getResult" v-if="type === false"/>
                                <Multiple :user="user" :type="type" @confirm="getResult" v-if="type === true"/>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Form from "../helpers/form";
import Single from "./request/Single";
import Multiple from "./request/Multiple";

export default {
    name: "Request",
    components: {Multiple, Single},
    props: [ 'user' ],
    mixins: [ Form ],
    data: () => ({
        loading: true,
        type: false
    }),
    created() {
        this.$emit('success');
    },
    mounted() {
        this.loading = false;
    },
    methods: {
        getResult() {
            this.$router.push({ name: 'Result' });
        }
    }
}
</script>

<style scoped>

</style>
